import React, { Suspense, Fragment, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Authenticated from "./Guard/Authenticated";
import Guest from "./Guard/Guest";
import LayoutStructrure from "./components/common/LayoutStructrure";
import CommonLayoutStructure from "./components/common/CommonLayoutStructure";

export function RenderRout() {
  return (
    <>
      <Router>
        <Suspense fallback={"....."}>
          <Routes>
            {routes?.map((route, i) => {
              const Guard = route?.guard || Fragment;
              const Auth = route?.auth || Fragment;
              const Layout = route?.layout || Fragment;
              const Component = route?.element;
              return (
                <Route
                  key={i}
                  path={route.path}
                  exact={route.exact}
                  element={
                    <Guard>
                      <Auth>
                        <Layout>
                          <Component />
                        </Layout>
                      </Auth>
                    </Guard>
                  }
                />
              );
            })}
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

const routes = [
  {
    layout: LayoutStructrure,
    exact: true,
    path: "/",
    element: lazy(() => import("./components/main/HomeMain")),
  },
  {
    guard: Guest,
    exact: true,
    path: "/signup",
    element: lazy(() => import("./components/auth/SignUp")),
  },
  {
    guard: Guest,
    exact: true,
    path: "/forgetpassword",
    element: lazy(() => import("./components/auth/Forgetpassword")),
  },

  {
    guard: Guest,
    exact: true,
    path: "/signin",
    element: lazy(() => import("./components/auth/Login")),
  },
  {
    guard: Guest,
    exact: true,
    path: "/otp",
    element: lazy(() => import("./components/auth/OtpVerify")),
  },
   {
    layout: CommonLayoutStructure,
    exact: true,
    path: "/tour",
    element: lazy(() => import("./components/pages/TourVideos/Index")),
  },
  {
    layout: CommonLayoutStructure,
    exact: true,
    path: "/setting",
    element: lazy(() => import("./components/pages/Appsetting/Index")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/myprofile",
    element: lazy(() => import("./components/auth/MyProfile")),
  },
  {
    layout: CommonLayoutStructure,
    exact: true,
    path: "/contact",
    element: lazy(() => import("./components/pages/contact/Index")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/personal-training",
    element: lazy(() => import("./components/pages/personal-training/Index")),
  },

  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/fun/challenges",
    element: lazy(() => import("./components/pages/challenges/Index")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/fun/challenges/edit/:id",
    element: lazy(() => import("./components/pages/challenges/Detiels")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/personal-training-all",
    element: lazy(() =>
      import("./components/pages/personal-training-detail/PlayAllVideo")
    ),
  },

  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/training/:id?/:name?",
    element: lazy(() =>
      import("./components/pages/personal-training/Allpersonaltraining")
    ),
  },

  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/personal-training-detail/:id?",
    element: lazy(() =>
      import("./components/pages/personal-training-detail/Index")
    ),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/skills",
    element: lazy(() => import("./components/pages/Skills/Index")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/trophy-room",
    element: lazy(() => import("./components/pages/trophy-room/Index")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/trophy-room-detail/:id",
    element: lazy(() =>
      import("./components/pages/trophy-room/TrophyroomDetail")
    ),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/all-trophy",
    element: lazy(() => import("./components/pages/trophy-room/Alltrophy")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/chats",
    element: lazy(() => import("./components/pages/Chats/Index")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/allocated-training",
    element: lazy(() => import("./components/pages/alocated-training/Index")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/allocated-training-detiels/:id",
    element: lazy(() => import("./components/pages/alocated-training/Detiels")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/fun",
    element: lazy(() => import("./components/pages/fun/index")),
  },

  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/players",
    element: lazy(() => import("./components/pages/coach/Players")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/invitation",
    element: lazy(() => import("./components/pages/Invitation/Index")),
  },
    {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/player-invitation",
    element: lazy(() => import("./components/pages/Invitation/PlayerInvite")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/players/:id",
    element: lazy(() => import("./components/pages/coach/PlayerDetail")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/program",
    element: lazy(() => import("./components/pages/coach/TrainingProgram")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/teams",
    element: lazy(() => import("./components/pages/coach/Teams/Index")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/teams/add/:id?",
    element: lazy(() => import("./components/pages/coach/Teams/AddeditTeam")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/program/add-training/:id?",
    element: lazy(() => import("./components/pages/coach/AddNewTrainingForm")),
  },

  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/program/submit",
    element: lazy(() => import("./components/pages/coach/SuccessSubmit")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/training-page",
    element: lazy(() => import("./components/pages/training/TrainingPage")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/training-page/detail/:id?/:name?",
    element: lazy(() => import("./components/pages/training/MytrainingDetail")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/training-page/complete/:id?/:name?",
    element: lazy(() => import("./components/pages/training/TrainingComplete")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/fun/quiz",
    element: lazy(() => import("./components/pages/quiz/Index")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/fun/quiz/start/:id/:name?",
    element: lazy(() => import("./components/pages/quiz/QuizDetail")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/fun/quiz/single-ques/:id/:name?",
    element: lazy(() => import("./components/pages/quiz/SingleQues")),
  },
   {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/fun/quiz/review/:id/:name?",
    element: lazy(() => import("./components/pages/quiz/Review")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/tracker",
    element: lazy(() => import("./components/pages/tracker/Index")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/tracker/add/:id?",
    element: lazy(() => import("./components/pages/tracker/AddRating")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/subscription",
    element: lazy(() => import("./components/pages/subscription/Index")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/notification",
    element: lazy(() => import("./components/pages/notification/Index")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/notes",
    element: lazy(() => import("./components/pages/notes/Page")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/profile/skill",
    element: lazy(() => import("./components/pages/notes/Skill")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/payment-cancel",
    element: lazy(() => import("./components/pages/payment/Cancelurl")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/payment-success",
    element: lazy(() => import("./components/pages/payment/Successurl")),
  },
  {
    layout: CommonLayoutStructure,
    guard: Authenticated,
    exact: true,
    path: "/payment-history",
    element: lazy(() => import("./components/pages/subscription/Paymenthistory")),
  },
  
];
